import React from 'react'
import { Tooltip } from 'src/components/Reusable/Tooltip'

export const truncate = ({
  text,
  chars = 20,
}: {
  text: string
  chars?: number
}): string =>
  text.length > chars ? `${text.substring(0, chars - 3)}...` : text

export const formatEvidenceCaption = (
  caption: string,
  isAutomated: boolean,
  truncate?: boolean,
  isViaRequest?: boolean,
  isControlShowPage?: boolean,
): JSX.Element | string => {
  const cleanedCaption = isAutomated ? caption.replaceAll('--', '-') : caption
  const formattedCaption = isControlShowPage
    ? cleanedCaption + (isViaRequest ? ' - via Request' : '')
    : cleanedCaption
  return truncate ? (
    <Tooltip
      id={formattedCaption}
      placement="top-end"
      tooltipBody={formattedCaption}
    >
      <>{`${formattedCaption.slice(0, 50)}...`}</>
    </Tooltip>
  ) : (
    formattedCaption
  )
}

/**
 * Extract a title from OE test procedure text.
 * Rules:
 * 1. If there's a **bold** section, use that
 * 2. If no bold but starts with whitespace/-, strip that and use up to the colon
 * 3. Otherwise, first 100 chars
 */
export const getOeTestTitle = (text: string): string => {
  // Check for **bold** text
  const boldMatch = text.match(/\*\*([^*]+)\*\*/)
  if (boldMatch) {
    return boldMatch[1].replace(/:$/, '').trim()
  }

  // Strip leading whitespace and dashes
  const stripped = text.replace(/^\s*-\s*/, '')

  // Check for colon
  const colonIndex = stripped.indexOf(':')
  if (colonIndex > 0 && colonIndex < 100) {
    return stripped.substring(0, colonIndex).trim()
  }

  // Return first 100 chars
  if (stripped.length > 100) {
    return stripped.substring(0, 100).trim() + '...'
  }

  return stripped.trim()
}

// Helper function to get enum key name from enum value
export const getEnumKeyName = (
  enumObject: Record<string, number | string>,
  value: number,
): string => {
  const key = Object.keys(enumObject).find(
    (k) => enumObject[k] === value && isNaN(Number(k)),
  )
  return key || (value.toString() as string)
}
